import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Sale1230SearchParamsSchema = z
  .object({
    status: z.string().optional(),
    fromDate: z.coerce.date().optional(),
    toDate: z.coerce.date().optional(),
    number: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)
export type Sale1230SearchParams = z.infer<typeof Sale1230SearchParamsSchema>

export const Sale1230SearchResultModelSchema = z.object({
  id: z.string(),
  number: z.string(),
  date: z.coerce.date(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  projectionWeeks: z.number(),
  generatedDate: z.coerce.date(),
})

export type Sale1230SearchResultModel = z.infer<
  typeof Sale1230SearchResultModelSchema
>

export const Sale1230SearchResultSchema = z
  .object({
    data: z.array(Sale1230SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Sale1230SearchResult = z.infer<typeof Sale1230SearchResultSchema>
